/* This example requires Tailwind CSS v2.0+ */
import { XCircleIcon } from '@heroicons/react/solid'
import { isArray } from 'lodash'

export default function ErrorAlert({ error, heading }) {
    heading = heading || 'Please fix following Errors'

    return (
        <div className="rounded-md bg-red-50 p-2 my-2">
            <div className="flex">
                <div className="flex-shrink-0">
                    <XCircleIcon
                        className="h-5 w-5 text-red-400"
                        aria-hidden="true"
                    />
                </div>
                <div className="ml-3">
                    {heading && (
                        <h3 className="text-sm font-medium text-red-800">
                            {heading}
                        </h3>
                    )}
                    <div className="mt-2 text-sm text-red-700">
                        {isArray(error) ? (
                            <ul
                                role="list"
                                className="list-disc pl-5 space-y-1">
                                {error.map((err, idx) => (
                                    <li key={idx}>{err}</li>
                                ))}
                            </ul>
                        ) : (
                            error
                        )}
                    </div>
                </div>
            </div>
        </div>
    )
}
